import { LoadingContainer, Model } from 'peach/components'
import { useParams } from 'peach/router'

import { Page } from 'core/components'
import { useInternalLoanExpectedPaymentsGet } from 'core/types'

import DeferScheduleModal from './ExpectedPayments/DeferScheduleModal'

const LoanExpectedPayments = () => {
  const { companyId, personId, loanId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
  }>()

  const {
    data: expectedPayments,
    isLoading,
    error,
    refetch,
  } = useInternalLoanExpectedPaymentsGet({
    companyId,
    personId,
    loanId,
  })

  return (
    <LoadingContainer error={error} loading={isLoading}>
      <DeferScheduleModal onSuccess={refetch} />
      <Page variant='full'>
        <Model.Item json={expectedPayments} title='Expected Payments' />
      </Page>
    </LoadingContainer>
  )
}

export default LoanExpectedPayments
